import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Smartphone } from "lucide-react";
import { applyPageSeo } from "../lib/seo";
import { businessDetails } from "../data/content";

const OPENING_HOURS = [
  { day: "Monday", hours: "9am – 7pm" },
  { day: "Tuesday", hours: "9am – 5pm" },
  { day: "Wednesday", hours: "2pm – 7pm" },
  { day: "Thursday", hours: "9am – 5pm" },
  { day: "Friday", hours: "9am – 12pm" },
];

export const LiveChatPage = () => {
  useEffect(() => {
    applyPageSeo({
      title: "Live Chat | Freeman Jones",
      description: "Chat with the Freeman Jones team in real time.",
      path: "/live-chat",
    });

    if (document.getElementById("cxone-loader")) return;

    const tenantId = "1406";
    const templateId = "e51cb587-7804-495f-a4aa-f5d7fd1612cc";
    const channelId = "chat_6e85b602-6df9-418c-a01b-e949a1dc44ca";
    const loaderUrl = "https://web-modules-de-uk1.niceincontact.com/loader/1/loader.js";

    const moduleName = "cxone";
    window.CXoneDfo = moduleName;
    window[moduleName] =
      window[moduleName] ||
      function () {
        (window[moduleName].q = window[moduleName].q || []).push(arguments);
      };
    window[moduleName].u = loaderUrl;

    const loader = document.createElement("script");
    loader.id = "cxone-loader";
    loader.type = "module";
    loader.src = loaderUrl + "?" + Math.floor(Date.now() / 3_600_000);
    document.head.appendChild(loader);

    window.cxone("init", tenantId, channelId);
    window.cxone("guide", "init", {
      templateId,
      channelId,
      locale: "en-GB",
      disableFormCaching: true,
    });
    window.cxone("chat", "sendFirstMessageAutomatically", true);

    if (!window.fwg) window.fwg = {};
    window.fwg.openLiveChat = function () {
      document.querySelector('[data-entrypoint="chat"]')?.click();
    };

    function waitAndTriggerLiveChat() {
      window.setTimeout(function () {
        const chatBtn = document.querySelector('[data-entrypoint="chat"]');
        if (chatBtn) {
          window.fwg.openLiveChat();
        } else {
          waitAndTriggerLiveChat();
        }
      }, 100);
    }

    waitAndTriggerLiveChat();
  }, []);

  return (
    <section id="top" data-testid="live-chat-page" className="bg-brand-bg">
      <div className="mx-auto max-w-3xl px-4 py-14 lg:px-8 lg:py-20">
        <Link
          to="/"
          className="inline-flex min-h-[44px] items-center gap-2 rounded-full text-sm font-semibold text-brand-teal transition-colors hover:text-brand-tealHover"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Back to homepage
        </Link>

        <h1 className="mt-6 font-heading text-4xl font-bold text-brand-navy sm:text-5xl">
          Live Chat
        </h1>
        <p className="mt-3 text-base leading-relaxed text-brand-body">
          Our live chat is loading — it should open automatically. If it doesn't, use the chat
          button in the corner of the screen.
        </p>

        <div className="mt-10 space-y-10">
          <section aria-labelledby="opening-hours">
            <h2
              id="opening-hours"
              className="font-heading text-base font-bold text-brand-navy md:text-lg"
            >
              Opening hours
            </h2>
            <div className="mt-3">
              <dl className="divide-y divide-brand-border">
                {OPENING_HOURS.map(({ day, hours }) => (
                  <div key={day} className="flex justify-between py-2.5 text-base text-brand-body">
                    <dt className="font-semibold text-brand-navy">{day}</dt>
                    <dd>{hours}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </section>

          <section
            aria-labelledby="app-promo"
            className="rounded-2xl border border-brand-border bg-white p-6"
          >
            <h2
              id="app-promo"
              className="font-heading text-base font-bold text-brand-navy md:text-lg"
            >
              Have you explored our new app?
            </h2>
            <p className="mt-3 text-base leading-relaxed text-brand-body">
              It offers real-time updates on the progress of your IVA and allows you to message us
              anytime, 24/7. We'll get back to you within 2 working days.
            </p>
            <Link
              to={businessDetails.customerAppUrl}
              className="mt-4 inline-flex min-h-[44px] items-center gap-2 rounded-full bg-brand-teal px-5 font-semibold text-white transition-colors hover:bg-brand-tealHover"
            >
              <Smartphone className="h-4 w-4" aria-hidden="true" />
              Download the app now
            </Link>
          </section>
        </div>
      </div>
    </section>
  );
};
